import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const csatWorkersCrudActionTypes = generateEntityCrudActionTypes('csatWorkers')

export default { ...csatWorkersCrudActionTypes }
